/**
 * Syncs the theme cart drawer when products are added from Rebuy widgets.
 * Uses Rebuy events: https://developers.rebuyengine.com/reference/widget-event-listeners
 * and https://developers.rebuyengine.com/reference/cart-event-listeners
 */
(function () {
  if (window.__rebuyCartSyncBound) return;
  window.__rebuyCartSyncBound = true;

  var refreshInFlight = false;
  var refreshQueued = false;
  var PRESERVE_SELECTORS = [
    '.globo_widget_24580',
    '[data-rebuy-id="301272"]',
    '#cart-drawer-recommendations-target',
  ];

  function getCartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function smartCartActive() {
    if (typeof window.rebuySmartCartActive === 'function') return window.rebuySmartCartActive();
    return document.body.classList.contains('smart-cart--enabled') && !!document.getElementById('rebuy-cart');
  }

  // Rebuy owns the cart UI but does not touch the theme's header count, so the
  // bubble is refreshed on its own instead of re-rendering the hidden drawer.
  function refreshCartIconBubble() {
    return fetch(getCartUrl() + '?sections=cart-icon-bubble')
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to refresh cart icon');
        return response.json();
      })
      .then(function (sections) {
        updateCartIconBubble(sections['cart-icon-bubble']);
      })
      .catch(function () {});
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function updateCartIconBubble(sectionHTML) {
    if (!sectionHTML) return;

    var cartIconBubble = document.getElementById('cart-icon-bubble');
    if (!cartIconBubble) return;

    var source = parseHTML(sectionHTML).querySelector('.shopify-section');
    if (!source) return;

    cartIconBubble.innerHTML = source.innerHTML;
  }

  function preserveNodes(container) {
    return PRESERVE_SELECTORS.map(function (selector) {
      return container.querySelector(selector);
    }).filter(Boolean);
  }

  function restorePreservedNodes(container, nodes) {
    PRESERVE_SELECTORS.forEach(function (selector) {
      container.querySelectorAll(selector).forEach(function (el) {
        el.remove();
      });
    });

    var upsells = container.querySelector('.cart-drawer__upsells');
    var footer = container.querySelector('.drawer__footer');

    nodes.forEach(function (node) {
      if (upsells) {
        upsells.appendChild(node);
      } else if (footer && footer.parentNode) {
        footer.parentNode.insertBefore(node, footer);
      } else {
        container.appendChild(node);
      }
    });
  }

  function updateRecommendationsTarget(cart) {
    var target = document.getElementById('cart-drawer-recommendations-target');
    if (!target) return;

    var productId = cart && cart.items && cart.items[0] ? cart.items[0].product_id : '';
    target.setAttribute('data-product-id', productId || '');

    if (typeof window.loadCartRecommendations === 'function') {
      window.loadCartRecommendations();
    }
  }

  function refreshThemeCartDrawer(options) {
    options = options || {};
    var shouldOpen = options.open !== false;
    var cartDrawer = document.querySelector('cart-drawer');

    if (smartCartActive()) return refreshCartIconBubble();

    if (!cartDrawer) return Promise.resolve();

    if (refreshInFlight) {
      refreshQueued = true;
      return Promise.resolve();
    }

    refreshInFlight = true;

    return fetch(getCartUrl() + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to refresh cart drawer');
        return response.json();
      })
      .then(function (sections) {
        var drawerWasOpen = cartDrawer.classList.contains('active');
        var sectionHTML = sections['cart-drawer'];
        var doc = parseHTML(sectionHTML);
        var drawerInner = cartDrawer.querySelector('.drawer__inner');
        var newInner = doc.querySelector('.drawer__inner');
        var newCartDrawerEl = doc.querySelector('cart-drawer');

        updateCartIconBubble(sections['cart-icon-bubble']);

        if (newCartDrawerEl) {
          cartDrawer.classList.toggle('is-empty', newCartDrawerEl.classList.contains('is-empty'));
        } else {
          cartDrawer.classList.remove('is-empty');
        }

        // When the drawer is already open (e.g. add from cart Rebuy widget),
        // keep live Rebuy/Globo nodes so widgets are not destroyed mid-session.
        if (drawerWasOpen && drawerInner && newInner) {
          var preserved = preserveNodes(drawerInner);
          preserved.forEach(function (node) {
            node.remove();
          });

          drawerInner.innerHTML = newInner.innerHTML;
          restorePreservedNodes(drawerInner, preserved);

          var overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
          if (overlay) {
            overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
          }
        } else if (typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents({
            id: null,
            sections: sections,
          });
        } else if (shouldOpen && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }

        if (drawerWasOpen && shouldOpen && typeof cartDrawer.open === 'function') {
          cartDrawer.classList.add('animate', 'active');
          document.body.classList.add('overflow-hidden');
        }

        return fetch(getCartUrl() + '.js')
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            updateRecommendationsTarget(cart);

            if (typeof publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'rebuy',
                cartData: cart,
              });
            }
          })
          .catch(function () {
            if (typeof window.loadCartRecommendations === 'function') {
              window.loadCartRecommendations();
            }
          });
      })
      .catch(function () {
        if (shouldOpen && cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      })
      .finally(function () {
        refreshInFlight = false;

        if (refreshQueued) {
          refreshQueued = false;
          refreshThemeCartDrawer(options);
        }
      });
  }

  window.refreshThemeCartDrawer = refreshThemeCartDrawer;
  window.refreshRebuyHomepageCartDrawer = refreshThemeCartDrawer;

  // Fires when a product is added from any Rebuy widget (including cart widget 301272)
  // https://developers.rebuyengine.com/reference/widget-event-listeners
  // Wait for cart sync (rebuy:cart.change) so section HTML is up to date.
  document.addEventListener('rebuy.add', function () {
    var completed = false;

    var runRefresh = function () {
      if (completed) return;
      completed = true;
      refreshThemeCartDrawer({ open: true });
    };

    document.addEventListener('rebuy:cart.change', runRefresh, { once: true });
    // Fallback if cart.change already fired or is skipped
    setTimeout(runRefresh, 400);
  });

  // Quantity changes and removals made inside the Smart Cart never reach the
  // theme, which would leave the header count showing a stale number.
  document.addEventListener('rebuy:cart.change', function () {
    if (smartCartActive()) refreshCartIconBubble();
  });
})();
